module.exports = __webpack_public_path__ + "68ccec75635547c13e6bd40122b2b49e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-10.png
// module id = 1419
// module chunks = 0